import { ServiceIdentifier } from '../service-locator';
import { WalletService } from './interfaces';

export * from './interfaces';

/**
 * The service locator identifier for the WalletService
 */
export const WALLET_SERVICE = ServiceIdentifier.get<WalletService>('WalletService');
